if (!customElements.get('deco-inspiration-products')) {
  customElements.define(
    'deco-inspiration-products',
    class DecoInspirationProducts extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';

        this.dialog = this.querySelector('[data-inspiration-dialog]');
        this.dialogContent = this.querySelector('[data-inspiration-dialog-content]');
        this.loadMoreButton = this.querySelector('[data-inspiration-load-more]');

        this.addEventListener('click', this.handleClick.bind(this));

        if (this.dialog) {
          this.dialog.addEventListener('click', (event) => {
            if (event.target === this.dialog) this.closeDialog();
          });
        }
      }

      handleClick(event) {
        const openButton = event.target.closest('[data-inspiration-products-open]');
        if (openButton && this.contains(openButton)) {
          this.openDialog(openButton.dataset.templateId);
          return;
        }

        const closeButton = event.target.closest('[data-inspiration-dialog-close]');
        if (closeButton && this.contains(closeButton)) {
          this.closeDialog();
          return;
        }

        const loadMoreButton = event.target.closest('[data-inspiration-load-more]');
        if (loadMoreButton && this.contains(loadMoreButton)) this.revealMore();
      }

      openDialog(templateId) {
        if (!this.dialog || !this.dialogContent || !templateId) return;

        const template = this.querySelector(`#${CSS.escape(templateId)}`);
        if (!template) return;

        this.dialogContent.replaceChildren(template.content.cloneNode(true));
        this.dialog.showModal();
        this.dialog.querySelector('[data-inspiration-dialog-close]')?.focus();
      }

      closeDialog() {
        if (this.dialog?.open) this.dialog.close();
      }

      revealMore() {
        const hiddenTiles = Array.from(this.querySelectorAll('[data-inspiration-tile][hidden]'));
        const revealCount = Number(this.dataset.revealCount) || 12;

        hiddenTiles.slice(0, revealCount).forEach((tile) => {
          tile.hidden = false;
        });

        if (hiddenTiles.length <= revealCount && this.loadMoreButton) {
          this.loadMoreButton.hidden = true;
        }
      }
    }
  );
}
